(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lit"), require("@lit/localize"), require("lit/decorators.js"), require("lit/directives/class-map.js"));
	else if(typeof define === 'function' && define.amd)
		define(["lit", "@lit/localize", "lit/decorators.js", "lit/directives/class-map.js"], factory);
	else if(typeof exports === 'object')
		exports["PWAInstallComponent"] = factory(require("lit"), require("@lit/localize"), require("lit/decorators.js"), require("lit/directives/class-map.js"));
	else
		root["PWAInstallComponent"] = factory(root["lit"], root["@lit/localize"], root["lit/decorators.js"], root["lit/directives/class-map.js"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__870__, __WEBPACK_EXTERNAL_MODULE__487__, __WEBPACK_EXTERNAL_MODULE__931__, __WEBPACK_EXTERNAL_MODULE__536__) => {
return 